const ProjectReadinessConfig = {
  id: "projectReadiness",
  title: "Am I Ready to Start This Project?",
  description:
    "Answer a few quick questions to understand how ready you are to move forward and what to do next.",
  ctaLabel: "Generate My Project Readiness Summary",
  loadingLabel: "Generating...",
  loadingMessage: "Generating your project readiness summary...",
  defaults: {
    projectType: "",
    projectGoal: "",
    hasBudgetRange: false,
    budgetRange: "",
    hasTimeline: false,
    timeline: "",
    urgency: "",
    projectSize: "",
    contractorReadiness: "",
  },
  projectTypeOptions: [
    "Repair",
    "Replacement",
    "Upgrade",
    "New installation",
    "Inspection / diagnosis",
    "Not sure",
  ],
  budgetRangeOptions: [
    "Under $500",
    "$500-$1,500",
    "$1,500-$5,000",
    "$5,000-$15,000",
    "$15,000+",
    "Not sure",
  ],
  timelineOptions: [
    "Next week",
    "Next month",
    "Within 3 months",
    "Within 6 months",
    "Flexible",
  ],
  urgencyOptions: [
    "Emergency",
    "Needs attention soon",
    "Planned improvement",
    "Just exploring",
  ],
  projectSizeOptions: [
    "Small repair",
    "Single room / area",
    "Multiple areas",
    "Whole-home or major project",
    "Not sure",
  ],
  contractorReadinessOptions: [
    "Yes",
    "Maybe after learning more",
    "Not yet",
  ],
  readinessLabels: {
    urgent: "Urgent",
    ready: "Ready",
    planning: "Planning",
    exploring: "Exploring",
    unclear: "Unclear",
  },
  result: {
    title: "Project Readiness Summary",
    disclaimer:
      "This summary is for planning purposes only and does not guarantee cost, timing, permits, or contractor availability.",
  },
};

export default ProjectReadinessConfig;
